module.exports = __webpack_public_path__ + "static/timely-reminder-employee-shifts-fc5352b0e853f93a7b0f3320ac81ed07.png";